import { render, staticRenderFns } from "./PostBlock.vue?vue&type=template&id=49cc551b&"
import script from "./PostBlock.vue?vue&type=script&lang=js&"
export * from "./PostBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports